/**
 * Numery zaufane opaski i ich aliasy backend trzyma jako dwa rownolegle CSV-y:
 * `whitelist_numbers` i `white_list_alias`. Para numer-alias trzyma sie wylacznie
 * pozycja na liscie, wiec niezalezne filtrowanie ktorejkolwiek z list przesuwa
 * aliasy na cudze numery. Cale parowanie siedzi w jednej funkcji nizej, a odczyt
 * z API i zapis do API korzystaja z tej samej reguly.
 */
export interface WhitelistEntry {
  number: string;
  alias: string | null;
}

/**
 * CSV-y z API -> pary numer+alias. Pusty numer odpada razem ze swoim aliasem:
 * pusta kolumna przychodzi jako '', a ''.split(',') dawaloby jedna pusta kontrolke,
 * ktora nie przechodzi walidacji i blokowala zapis CALEGO formularza opaski.
 */
export function parseWhitelistEntries(
  numbersCsv: string | null,
  aliasesCsv: string | null
): WhitelistEntry[] {
  return pairByPosition(splitCsv(numbersCsv), splitCsv(aliasesCsv));
}

/** Wartosci z FormArray-ow -> para CSV-ow dla API. */
export function serializeWhitelistEntries(
  numbers: (string | null)[],
  aliases: (string | null)[]
): { whitelistNumbers: string, whiteListAlias: string } {
  const entries = pairByPosition(numbers || [], aliases || []);

  return {
    whitelistNumbers: entries.map(entry => entry.number).join(','),
    // Numer bez aliasu musi zostawic pusta pozycje ("Dom," / ",Praca"), inaczej alias
    // wskoczylby na numer wyzej. Gdy zaden numer nie ma aliasu, wysylamy pusty string
    // zamiast samych przecinkow — tak jak przed dodaniem aliasow.
    whiteListAlias: entries.some(entry => entry.alias)
      ? entries.map(entry => toCsvField(entry.alias)).join(',')
      : ''
  };
}

/** Jedyne miejsce, w ktorym numer spotyka sie ze swoim aliasem. */
function pairByPosition(
  numbers: (string | null)[],
  aliases: (string | null)[]
): WhitelistEntry[] {
  return numbers
    .map((number, i) => ({ number: number, alias: aliases[i] !== undefined ? aliases[i] : null }))
    .filter(entry => entry.number !== null && entry.number !== '');
}

function splitCsv(csv: string | null): string[] {
  return csv ? csv.split(',') : [];
}

/** Alias jest wpisywany recznie, a przecinek w nim rozjechalby cala liste o pozycje. */
function toCsvField(alias: string | null): string {
  return alias ? alias.replace(/,/g, ' ') : '';
}
